var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useRef, useEffect } from "react";
import useToggle from "../../hooks/use-toggle";
import { mergeRefs } from "../../utils";
var useCheckbox = function (_a) {
    var onChange = _a.onChange, indeterminate = _a.indeterminate, disabled = _a.disabled, checked = _a.checked;
    var _b = useToggle(), isFocused = _b[0], focusOn = _b[2], focusOff = _b[3];
    var checkboxInputRef = useRef(null);
    var handleChange = useCallback(function (event) {
        if (disabled) {
            event.preventDefault();
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    }, [disabled, onChange]);
    useEffect(function () {
        if (checkboxInputRef.current) {
            checkboxInputRef.current.indeterminate = Boolean(indeterminate);
        }
    }, [indeterminate]);
    var getCheckBoxProps = useCallback(function () {
        return {
            "data-focus": isFocused ? "" : undefined,
            "data-disabled": disabled ? "" : undefined,
            indeterminate: indeterminate,
            checked: checked,
        };
    }, [isFocused, disabled, checked, indeterminate]);
    var getInputProps = useCallback(function (forwardedRef, props) {
        if (forwardedRef === void 0) { forwardedRef = null; }
        return __assign(__assign({}, props), { type: "checkbox", ref: mergeRefs(checkboxInputRef, forwardedRef), onChange: handleChange, onFocus: focusOn, onBlur: focusOff, checked: checked, disabled: disabled });
    }, [focusOff, focusOn, handleChange, checked, disabled]);
    var state = {
        disabled: disabled,
        indeterminate: indeterminate,
        checked: checked,
        isFocused: isFocused,
    };
    return { getCheckBoxProps: getCheckBoxProps, getInputProps: getInputProps, state: state };
};
export default useCheckbox;
